import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import { MATH_XMLNS } from '../../lib/checker';
import { parseMfenced } from '../../lib/utils';

const Container = styled.div`
    line-height: 1.5em;
    .MathJax {
        outline: none;
    }
    .math {
        vertical-align: middle;
        background: inherit;
        overflow: hidden;
        outline: none;
    }
`;

const MathContent = ({ children, onRendered, inTabOrder = true, parseContent = true, ...props }) => {
    let parsedChildren = children;
    const containerRef = useRef(null);

    const renderMath = useCallback(() => {
        if(!!MathJax && !!MathJax.typesetClear && !!containerRef.current) {
            MathJax.typesetClear([containerRef.current]);
            MathJax.typesetPromise([containerRef.current]).then(() => onRendered && onRendered());
        } else {
            setTimeout(renderMath, 1000);
        }
    }, [onRendered]);

    useEffect(() => {
        renderMath();
    }, [onRendered]);

    if (typeof children === 'string') {
        if (!children.includes(MATH_XMLNS) || !parseContent) {
            return <Container dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parsedChildren) }} {...props} />;
        } else {
            const options = {
                replace: (domNode) => {
                    //Replace <mfenced> tag as suggested here: https://developer.mozilla.org/en-US/docs/Web/MathML/Element/mfenced
                    if (domNode.name && domNode.name === 'mfenced') {
                        return parseMfenced(domNode, options);
                    }
                },
            };
            parsedChildren = parse(children, options);
        }
    }
    return <Container ref={containerRef} {...props}>{parsedChildren}</Container>;
};

MathContent.propTypes = {
    children: PropTypes.node,
    inTabOrder: PropTypes.bool,
    onRendered: PropTypes.func,
    parseContent: PropTypes.bool,
};

export default MathContent;
